import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import mainHelper, {apiCall} from "../../../helpers/MainHelper";
import ReactLoading from "react-loading";
import Swal from "sweetalert2";

class CategoryDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            isLoad:true,
            subCategoryLoading: false,
            subCategorySaveLoading: false,
            editingSubId: null,
            category: null,
            subCategories: [],
            formData : {
                name:'',
                description:''
            },
            newSubCategory: {
                name: '',
                description: ''
            }
        }
    }

    async componentDidMount() {
        await Promise.all([
            this.fetchCategoryDetail(),
            this.fetchSubCategories()
        ]);
        this.setState({isLoad: false});
    }

    fetchCategoryDetail = async () => {
        const {id} = this.props.match.params;
        try {
            const response = await apiCall(`business/stock/category/info/${id}`,'get');
            if(response.status === 'success' && response.data) {
                this.setState({
                    category: response.data,
                    formData: {
                        name: response.data.name || '',
                        description: response.data.description || ''
                    }
                });
            } else {
                // API'den data gelmedi, boş bir kategori oluştur
                this.setState({
                    category: {id: id, name: 'Kategori Bulunamadı'},
                    formData: {name: '', description: ''}
                });
                mainHelper.toastMessage('error', 'Kategori bilgisi yüklenemedi');
            }
        } catch (e) {
            console.error('Kategori detay hatası:', e);
            this.setState({
                category: {id: id, name: 'Hata Oluştu'},
                formData: {name: '', description: ''}
            });
            mainHelper.toastMessage('error', 'Kategori yüklenirken hata oluştu');
        }
    }

    fetchSubCategories = async () => {
        const {id} = this.props.match.params;
        try {
            const response = await apiCall(`business/stock/category/all?parent_id=${id}`,'get');
            // API response formatı: {data: [...], total: ...}
            if(response && response.data) {
                this.setState({subCategories: response.data || []});
            } else {
                this.setState({subCategories: []});
            }
        } catch (e) {
            console.error('Alt kategoriler yüklenirken hata:', e);
            this.setState({subCategories: []});
        }
    }

    handleChange = (e) => {
        const {id,value} = e.target;
        this.setState(prevState => ({
            formData : {
                ...prevState.formData,
                [id] : value
            }
        }))
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({loading:true});
        const {formData} = this.state;
        const {id} = this.props.match.params;
        const categoryFormData = new FormData();
        Object.keys(this.state.formData).forEach(key => {
            if(formData[key]) {
                categoryFormData.append(key,formData[key]);
            }
        });

        try {
            const response = await apiCall(`business/stock/category/update/${id}`,'post',categoryFormData);
            this.setState({loading:false});
            mainHelper.toastMessage(response.status,response.message);
            if(response.status === 'success') {
                this.fetchCategoryDetail();
            }
        }catch (e) {
            this.setState({loading:false});
        }
    }

    // Alt kategori ekleme
    handleSubCategoryChange = (e) => {
        const {name, value} = e.target;
        this.setState(prevState => ({
            newSubCategory: {
                ...prevState.newSubCategory,
                [name]: value
            }
        }));
    }

    handleAddSubCategory = async (e) => {
        e.preventDefault();
        const {id} = this.props.match.params;
        const {newSubCategory} = this.state;

        if(!newSubCategory.name.trim()) {
            mainHelper.toastMessage('error', 'Alt kategori adı gerekli!');
            return;
        }

        this.setState({subCategoryLoading: true});
        const subCategoryFormData = new FormData();
        subCategoryFormData.append('name', newSubCategory.name);
        subCategoryFormData.append('parent_id', id);
        if(newSubCategory.description) {
            subCategoryFormData.append('description', newSubCategory.description);
        }

        try {
            const response = await apiCall('business/stock/category/add','post',subCategoryFormData);
            mainHelper.toastMessage(response.status,response.message);
            if(response.status === 'success') {
                this.setState({
                    newSubCategory: {name: '', description: ''},
                    subCategoryLoading: false
                });
                this.fetchSubCategories();
            } else {
                this.setState({subCategoryLoading: false});
            }
        }catch (e) {
            this.setState({subCategoryLoading: false});
        }
    }

    // Alt kategori inline düzenleme
    handleEditSubCategory = (subId) => {
        this.setState({editingSubId: subId});
    }

    handleSubCategoryInputChange = (subId, field, value) => {
        this.setState(prevState => ({
            subCategories: prevState.subCategories.map(sub =>
                sub.id === subId ? {...sub, [field]: value} : sub
            )
        }));
    }

    handleSaveSubCategory = async (subId) => {
        this.setState({subCategorySaveLoading:true});
        const subCategory = this.state.subCategories.find(s => s.id === subId);
        if(!subCategory) {
            this.setState({subCategorySaveLoading:false});
            return
        };

        const subCategoryFormData = new FormData();
        subCategoryFormData.append('name', subCategory.name);
        subCategoryFormData.append('parent_id', this.props.match.params.id);
        if(subCategory.description) {
            subCategoryFormData.append('description', subCategory.description);
        }

        try {
            const response = await apiCall(`business/stock/category/update/${subId}`,'post',subCategoryFormData);
            mainHelper.toastMessage(response.status,response.message);
            if(response.status === 'success') {
                this.setState({editingSubId: null});
                this.fetchSubCategories();
                this.setState({subCategorySaveLoading:false});
            }
        }catch (e) {
            this.setState({subCategorySaveLoading:false});
            console.error(e);
        }
    }

    handleCancelEdit = () => {
        this.setState({editingSubId: null});
        this.fetchSubCategories(); // Revert changes
    }

    handleDeleteSubCategory = async (subId) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır'
        });

        if (result.isConfirmed) {
            try {
                const response = await apiCall(`business/stock/category/delete/${subId}`,'delete');
                mainHelper.toastMessage(response.status, response.message);
                if(response.status === 'success') {
                    this.fetchSubCategories();
                }
            } catch (e) {
                console.error(e);
            }
        }
    }

    render() {
        const {loading, isLoad, subCategoryLoading, subCategorySaveLoading, category, subCategories, formData, newSubCategory, editingSubId} = this.state;

        // Loader - veriler yüklenene kadar göster
        if (isLoad) {
            return (
                <div style={{ flex: 1 }}>
                    <div className="page-loader-wrapper" style={{display: 'block'}}>
                        <div className="loader" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            <div className="m-t-30">
                                <img src={require('../../../assets/images/logo-white.png')} width="150" alt="Servicezone"/>
                            </div>
                            <p>Yükleniyor</p>
                            <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Ana Kategori Detay"
                            Breadcrumb={[
                                { name: "Stok Yönetimi", navigate: "" },
                                { name: "Ana Kategoriler", navigate: "stock/categories" },
                                { name: category?.name || 'Kategori', navigate: "" },
                            ]}
                        />

                        {/* Ana Kategori Düzenleme */}
                        <div className="row clearfix">
                            <div className="col-lg-6">
                                <div className="card">
                                    <div className="header">
                                        <h2>Ana Kategori Bilgileri</h2>
                                    </div>
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="body">
                                            <div className="form-group">
                                                <label>Kategori Adı *</label>
                                                <input
                                                    id="name"
                                                    className="form-control"
                                                    placeholder="Kategori Adı"
                                                    type="text"
                                                    value={formData.name}
                                                    onChange={this.handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Açıklama</label>
                                                <textarea
                                                    id="description"
                                                    className="form-control"
                                                    placeholder="Açıklama"
                                                    rows="3"
                                                    value={formData.description}
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            {loading ? (
                                                <button className="btn btn-primary btn-block" disabled={true}>
                                                    <ReactLoading type="spin" width={'20px'} height={'20px'} color="#fff" />
                                                </button>
                                            ) :
                                            <button className="btn btn-primary btn-block" type="submit">
                                                Güncelle
                                            </button>}
                                        </div>
                                    </form>
                                </div>
                            </div>

                            {/* Alt Kategori Ekleme Formu */}
                            <div className="col-lg-6">
                                <div className="card">
                                    <div className="header bg-success text-white">
                                        <h2 className="text-white">Alt Kategori Ekle</h2>
                                    </div>
                                    <form onSubmit={this.handleAddSubCategory}>
                                        <div className="body">
                                            <div className="form-group">
                                                <label>Alt Kategori Adı *</label>
                                                <input
                                                    name="name"
                                                    className="form-control"
                                                    placeholder="Örn: Motor Parçaları, Fren Sistemleri"
                                                    type="text"
                                                    value={newSubCategory.name}
                                                    onChange={this.handleSubCategoryChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Açıklama</label>
                                                <textarea
                                                    name="description"
                                                    className="form-control"
                                                    placeholder="Açıklama"
                                                    rows="3"
                                                    value={newSubCategory.description}
                                                    onChange={this.handleSubCategoryChange}
                                                />
                                            </div>
                                            {subCategoryLoading ? (
                                                <button className="btn btn-success btn-block" disabled={true} style={{textAlign: "-webkit-center"}}>
                                                    <ReactLoading type="spin" width={'20px'} height={'20px'} color="#fff" />
                                                </button>
                                            ) :
                                            <button className="btn btn-success btn-block" type="submit">
                                                <i className="icon-plus"></i> Alt Kategori Ekle
                                            </button>}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        {/* Alt Kategoriler Listesi */}
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="header">
                                        <h2>Alt Kategoriler ({subCategories.length})</h2>
                                    </div>
                                    <div className="body">
                                        {subCategories.length === 0 ? (
                                            <div className="alert alert-info">
                                                Henüz alt kategori eklenmemiş. Yukarıdaki formu kullanarak alt kategori ekleyebilirsiniz.
                                            </div>
                                        ) : (
                                            <div className="table-responsive">
                                                <table className="table table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th style={{width: '50px'}}>ID</th>
                                                            <th>Alt Kategori Adı</th>
                                                            <th>Açıklama</th>
                                                            <th style={{width: '200px'}} className="text-center">İşlemler</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {subCategories.map(sub => (
                                                            <tr key={sub.id}>
                                                                <td>{sub.id}</td>
                                                                <td>
                                                                    {editingSubId === sub.id ? (
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-sm"
                                                                            value={sub.name}
                                                                            onChange={(e) => this.handleSubCategoryInputChange(sub.id, 'name', e.target.value)}
                                                                        />
                                                                    ) : (
                                                                        <span className="font-weight-bold">{sub.name}</span>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {editingSubId === sub.id ? (
                                                                        <textarea
                                                                            className="form-control form-control-sm"
                                                                            rows="2"
                                                                            value={sub.description || ''}
                                                                            onChange={(e) => this.handleSubCategoryInputChange(sub.id, 'description', e.target.value)}
                                                                        />
                                                                    ) : (
                                                                        <span className="text-muted">{sub.description || '-'}</span>
                                                                    )}
                                                                </td>
                                                                <td className="text-center">
                                                                    {editingSubId === sub.id ? (
                                                                        <>
                                                                            {subCategorySaveLoading ? (
                                                                                    <button
                                                                                        className="btn btn-sm btn-success mr-1"
                                                                                        disabled={true}
                                                                                        style={{textAlign: "-webkit-center"}}>
                                                                                        <ReactLoading type="spin"
                                                                                                      width={'20px'}
                                                                                                      height={'20px'}
                                                                                                      color="#fff"/>
                                                                                    </button>
                                                                                ) :
                                                                                <button
                                                                                    className="btn btn-sm btn-success mr-1"
                                                                                    onClick={() => this.handleSaveSubCategory(sub.id)}
                                                                                >
                                                                                    <i className="icon-check"></i> Kaydet
                                                                                </button>
                                                                            }
                                                                            <button
                                                                                className="btn btn-sm btn-secondary"
                                                                                onClick={this.handleCancelEdit}
                                                                            >
                                                                                <i className="icon-close"></i> İptal
                                                                            </button>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <button
                                                                                className="btn btn-sm btn-info mr-1"
                                                                                onClick={() => this.handleEditSubCategory(sub.id)}
                                                                            >
                                                                                <i className="icon-pencil"></i> Düzenle
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-sm btn-danger"
                                                                                onClick={() => this.handleDeleteSubCategory(sub.id)}
                                                                            >
                                                                                <i className="icon-trash"></i> Sil
                                                                            </button>
                                                                        </>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({stockReducer}) => ({});

export default withRouter(connect(mapStateToProps, {})(CategoryDetail));
